export default "__VITE_ASSET__Bbxmipb8__"